import React from 'react';
import ToggleButton from 'Components/ToggleButton/ToggleButton';

const Toggle = ({ fieldProps: { onChange, value }, title, name }) => {
  return (
    <div className="toggle-field">
      <p className="toggle-field__title">{title}</p>
      <ToggleButton
        onToggleChange={onChange}
        toggleStatus={!!value}
        inversion={true}
        extractToggle={true}
        id={`switch-${name}`}
      />
    </div>
  );
};

export default Toggle;
